import _ from "lodash";
import { initialLoading, handleOnPropsChanged, handleProductIdChanged, isPropChanged } from 'public/Shared/Design.js';
import { detectProductPage } from 'public/Store/store-helper.js';
import store from 'store';

$w.onReady(async function () {
    await detectProductPage();
    await initialLoading();
});

$widget.onPropsChanged(async (oldProps, newProps) => {
    store.set('props', newProps);
    store.set('oldProps', oldProps);

    if (isPropChanged('noOfItemsForSlider') ||
        isPropChanged('selectedTemplate') ||
        isPropChanged('showProductAddToCartButtonToggleValue') ||
        isPropChanged('showProductDescriptionToggleValue') ||
        isPropChanged('showProductPriceToggleValue') ||
        isPropChanged('showProductNameToggleValue') ||
        isPropChanged('showProductImgToggleValue') ||
        isPropChanged('showVariantDropdowns') ||
        isPropChanged('newVisitorMethod')) {
        await handleOnPropsChanged(newProps);
    }

    if (isPropChanged('productId')) {
        await handleProductIdChanged(newProps);
    }
});